import React from "react";
import classNames from "classnames";
const Section = ({ children, className, ...props }) => (
  <div className={classNames("section pb-4", className)} {...props}>
    <div className="section-content">{children}</div>
  </div>
);

export default Section;
